export function useFeatures() {
  return {
    useHistory: false,
    usePrint: false,
    useHelperPoint: false,
    useParkIconText: false,
    useShowEquipmentInSlideOutPanel: false,
    useShowBookingServiceUpdateDesc: false,
    useFindGoogleMapRoute: false,
    useFirstAidUserFilter: false,
    useEditBookingServiceItems: false,
    useStandaloneResourceBooking: false
  };
}
